import { z } from 'zod';
import { AuditSchema } from './audit-schema';

/**
 * SLUG SCHEMA
 * Ubicación: Root /slugs/{slug_text}
 * Propósito: Registro global de URLs únicas para la landing page.
 */
export const SlugSchema = z.object({
  // El texto del slug validado para URLs (ej: "barberia-el-chamo")
  slug: z
    .string()
    .min(3, 'Mínimo 3 caracteres')
    .regex(/^[a-z0-9-]+$/, 'Solo minúsculas, números y guiones'),

  // Indica si la landing page debe mostrar un perfil individual o un equipo
  entityType: z.enum(['professional', 'business']),

  // Referencia directa al ID dentro de la colección unificada /owners/
  ownerId: z.string(),

  // Estado para desactivar la página sin borrar el slug (útil para suspensiones)
  active: z.boolean().default(true),

  // Estándar de auditoría para rastrear la creación
  audit: AuditSchema,
});

export type Slug = z.infer<typeof SlugSchema>;
export type SlugWithId = Slug & { id: string };
